import { render, staticRenderFns } from "./ProductsDetail.vue?vue&type=template&id=2a016e46&"
import script from "./ProductsDetail.vue?vue&type=script&lang=js&"
export * from "./ProductsDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProductsDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports